/* unplugin-vue-components disabled */import script from "./SeriesActionChoiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SeriesActionChoiceDialog.vue?vue&type=script&setup=true&lang=js"

import "./SeriesActionChoiceDialog.vue?vue&type=style&index=0&id=7c67a35e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c67a35e"]])

export default __exports__